export const NOOP_ACTION = '@@NOOP_ACTION'
export const noopAction = () => ({
    type: NOOP_ACTION,
})
